import React from 'react';

const paths = {
  mountain: 'M2 20 9 5l5 10 3-6 5 11H2ZM6 11l3 3 3-3',
  heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.9M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm8-7.9a4 4 0 0 1 0 7.8',
  temple: 'M3 21h18M5 21V11h14v10M3 11l9-8 9 8M9 21v-6h6v6M12 3V1',
  leaf: 'M20 3C9 2 3 8 5 15c2 7 15 7 15-12ZM3 21l11-11',
  briefcase: 'M8 6V3h8v3M3 6h18v15H3V6Zm0 7c6 3 12 3 18 0M10 13h4',
  pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  phone: 'M22 16.9v3a2 2 0 0 1-2.2 2A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7l.7 2.8a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.4-1.3a2 2 0 0 1 2.1-.5l2.8.7a2 2 0 0 1 1.7 2Z',
  clock: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 6v6l4 2',
  shield: 'M12 2 3 6v6c0 6 9 10 9 10s9-4 9-10V6l-9-4ZM8 12l3 3 5-6',
  car: 'M3 13 5 5h14l2 8M3 13h18v6H3v-6Zm2 6v3m14-3v3M6 16h2m8 0h2',
  chat: 'M21 3H3v15h5v4l5-4h8V3ZM7 8h10M7 12h7',
  arrow: 'M5 12h14m-6-6 6 6-6 6',
  compass: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM16 8l-3 5-5 3 3-5 5-3Z',
};

export default function Icon({ name = 'compass', size = 22, ...props }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className="site-icon" {...props}><path d={paths[name] || paths.compass} /></svg>;
}
